import React from 'react';
import './AboutSection.css';
import degreeIcon from '../asset/icons/degree-hat-icon.svg';
import certificateIcon from '../asset/icons/certificate-icon.svg';
import aboutImage from '../asset/images/sara-bocca-restauri-immagine-profilo.webp';

const AboutSection = () => {
  return (
    <section className="about-section" id="chi-sono">
      <div className="about-container">
        <div className="about-text">
          <div className="about-circle circle-1"></div>
          <div className="about-circle circle-2"></div>
          <div className="about-circle circle-3"></div>
          
          <div className="about-header">
            <h2>Chi sono</h2>
            <div className="about-description">
              <p>
                Sono <strong>Sara Bocca</strong>, restauratrice di beni culturali specializzata nel recupero e nella conservazione di opere d'arte e manufatti storici, basata su Vigevano (PV) ma attiva in tutto il nord Italia.
              </p>
              <p>
                La mia formazione universitaria e l'esperienza sul campo mi hanno permesso di sviluppare competenze specifiche nel restauro di dipinti, affreschi, opere e arredi lignei e materiali lapidei.
              </p>
              <p>
                Sono convinta che ogni opera d'arte racconti una storia che merita di essere preservata per le generazioni future.
              </p>
              <p>
                Il mio approccio combina tecniche tradizionali con metodologie all'avanguardia, garantendo interventi rispettosi dell'integrità storica e artistica di ogni manufatto.
              </p>
            </div>
          </div>
          
          <div className="education-container">
            <div className="education-item">
              <div className="education-icon-container">
                <img src={degreeIcon} alt="Educazione" className="education-icon" />
              </div>
              <div className="education-text">
                <p className="education-title">Accademia delle Belle Arti di Brera, Milano</p>
                <p className="education-description">Restauratore di Beni Culturali, Settore 3-4-5</p>
              </div>
            </div>
            
            <div className="education-item">
              <div className="education-icon-container">
                <img src={certificateIcon} alt="Certificazione" className="education-icon" />
              </div>
              <div className="education-text">
                <p className="education-title">Iscritta all'</p>
                <p className="education-description">Elenco dei Restauratori di Beni Culturali del MiC</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="about-image-container">
          <div className="about-circle bg-circle-1"></div>
          <div className="about-circle bg-circle-2"></div>
          <div className="about-circle bg-circle-3"></div>
          <div className="about-circle bg-circle-4"></div>
          <div className="about-image" style={{ backgroundImage: `url(${aboutImage})` }}></div>
        </div>
      </div>
      
      <svg width="100%" height="44" viewBox="0 0 1280 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="wave-divider" preserveAspectRatio="none">
        <path d="M0 43.9736H1280V20.8799C879 -39.1872 472.5 57.1138 0 35.0602V43.9736Z" fill="#F9F6EE"/>
      </svg>
    </section>
  );
};

export default AboutSection;
